import React, { useState } from "react";
import { useData, save } from "../hooks/useData";
import { toast } from "sonner";
import { PageHeader, DataTable, Button, Modal, Field, Input, Textarea, Select, StatusBadge } from "../components/shared";
import { Plus } from "lucide-react";
import { num } from "../lib/api";

const PROCESSES = ["Cutting", "Embroidery", "Printing", "Emboss", "Stitching", "Bartec", "Washing", "Thread Cutting", "Checking", "Finishing"];

export default function Jobbers() {
  const { data, loading, reload } = useData("/jobbers");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(null);

  const blank = { name: "", address: "", contact_person: "", phone: "", gstin: "", pan: "", processes: [], rate: "", opening_balance: 0, active: true, remarks: "" };
  const edit = (r) => { setForm(r ? { ...r } : blank); setOpen(true); };
  const submit = async (e) => {
    e.preventDefault();
    const method = form.id ? "put" : "post";
    const path = form.id ? `/jobbers/${form.id}` : "/jobbers";
    await save(method, path, form);
    toast.success("Jobber saved");
    setOpen(false); reload();
  };
  const toggleProc = (p) => {
    const has = form.processes.includes(p);
    setForm({ ...form, processes: has ? form.processes.filter((x) => x !== p) : [...form.processes, p] });
  };

  const columns = [
    { key: "name", header: "Jobber Name", render: (r) => <span className="font-medium text-slate-800">{r.name}</span> },
    { key: "contact_person", header: "Contact" },
    { key: "phone", header: "Phone" },
    { key: "processes", header: "Processes", render: (r) => (r.processes || []).join(", ") || "-", sortable: false },
    { key: "rate", header: "Rate", align: "right", render: (r) => num(r.rate) },
    { key: "gstin", header: "GSTIN", mono: true },
    { key: "active", header: "Status", render: (r) => <StatusBadge status={r.active ? "Active" : "Inactive"} /> },
    { key: "act", header: "", sortable: false, render: (r) => <Button size="sm" variant="ghost" onClick={(e) => { e.stopPropagation(); edit(r); }}>Edit</Button> },
  ];

  return (
    <div>
      <PageHeader title="Jobber Master" subtitle="Outside job workers / contractors">
        <Button onClick={() => edit(null)} data-testid="add-jobber-btn"><Plus size={15} /> Add Jobber</Button>
      </PageHeader>
      {!loading && <DataTable testid="jobbers-table" columns={columns} rows={data} exportName="jobbers.csv" onRowClick={(r) => edit(r)} />}
      <Modal open={open} onClose={() => setOpen(false)} title={form?.id ? "Edit Jobber" : "Add Jobber"} wide>
        {form && (
          <form onSubmit={submit} className="grid grid-cols-2 gap-4">
            <Field label="Jobber Name" required><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="jobber-name" /></Field>
            <Field label="Contact Person"><Input value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} /></Field>
            <Field label="Phone"><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Field>
            <Field label="Rate"><Input type="number" value={form.rate} onChange={(e) => setForm({ ...form, rate: e.target.value })} /></Field>
            <Field label="GSTIN"><Input value={form.gstin} onChange={(e) => setForm({ ...form, gstin: e.target.value })} /></Field>
            <Field label="PAN"><Input value={form.pan} onChange={(e) => setForm({ ...form, pan: e.target.value })} /></Field>
            <Field label="Opening Balance"><Input type="number" value={form.opening_balance} onChange={(e) => setForm({ ...form, opening_balance: e.target.value })} /></Field>
            <Field label="Active"><Select value={form.active ? "1" : "0"} onChange={(e) => setForm({ ...form, active: e.target.value === "1" })} options={[{ value: "1", label: "Active" }, { value: "0", label: "Inactive" }]} /></Field>
            <Field label="Address" className="col-span-2"><Textarea value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></Field>
            <Field label="Process Capability" className="col-span-2">
              <div className="flex flex-wrap gap-2">
                {PROCESSES.map((p) => (
                  <button type="button" key={p} onClick={() => toggleProc(p)}
                    className={`px-2.5 py-1 rounded-full text-xs border ${form.processes.includes(p) ? "bg-blue-800 text-white border-blue-800" : "bg-white text-slate-600 border-slate-300"}`}>
                    {p}
                  </button>
                ))}
              </div>
            </Field>
            <div className="col-span-2 flex justify-end gap-2 pt-2">
              <Button type="button" variant="secondary" onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="submit" data-testid="jobber-save">Save Jobber</Button>
            </div>
          </form>
        )}
      </Modal>
    </div>
  );
}
